import { ShieldCheck, Phone, PhoneCall } from "lucide-react";
import asset from "../lib/asset";

var PHONE_NUMBER = "+7 (812) 313-98-98";
var PHONE_HREF = "tel:+78123139898";

var MEASURES = [
  {
    num: "01",
    title: "Ограничиваем доступ",
    text: "Персональные данные доступны только сотрудникам, которым они необходимы для работы с обращением пациента.",
  },
  {
    num: "02",
    title: "Используем защищённые системы",
    text: "Храним информацию в рабочих сервисах с разграничением доступа и контролем учётных записей.",
  },
  {
    num: "03",
    title: "Работаем через официальные каналы",
    text: "Для рекламы и коммуникации используем проверенные площадки и официальные контакты клиники.",
  },
  {
    num: "04",
    title: "Реагируем на нарушения",
    text: "Фиксируем подозрительные обращения и принимаем меры, если обнаруживаем неправомерное использование контактов.",
  },
];

export default function FraudWarningSection() {
  return (
    <section data-testid="fraud-warning" className="bg-brand-600 text-white py-14 md:py-20">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <p className="text-xs md:text-sm font-semibold uppercase tracking-widest text-white/70 mb-3">
          Важно для пациентов
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10 items-start mb-8 md:mb-10">
          <div className="lg:col-span-2">
            <h2 data-testid="fraud-warning-title" className="font-heading text-2xl md:text-4xl font-bold leading-tight mb-4">
              Будьте бдительны:
              <br className="hidden md:block" /> участились случаи мошенничества
            </h2>
            <p className="text-base md:text-lg text-white/90 leading-relaxed">
              Оставляли заявку в «НС Мед / Наша Стоматология», а затем получили звонок
              от другой клиники? К сожалению, подобные случаи незаконного использования
              контактов пациентов действительно встречаются.
            </p>
          </div>

          <div className="rounded-2xl bg-white/15 border border-white/20 p-5 md:p-6">
            <p className="font-semibold text-base md:text-lg mb-2">
              Сомневаетесь, кто вам звонит?
            </p>
            <p className="text-sm md:text-base text-white/90 leading-relaxed">
              Не передавайте личные данные. Перезвоните в клинику по официальному
              номеру — мы подтвердим обращение.
            </p>
            <a
              href={PHONE_HREF}
              data-testid="fraud-warning-aside-phone"
              className="inline-flex items-center gap-2 mt-4 text-base md:text-lg font-bold hover:text-brand-100 transition-colors"
            >
              <PhoneCall className="w-5 h-5 flex-shrink-0" />
              {PHONE_NUMBER}
            </a>
          </div>
        </div>

        {/* Врач */}
        <div className="rounded-3xl bg-white text-slate-800 overflow-hidden mb-8 md:mb-10">
          <div className="grid grid-cols-1 md:grid-cols-5 items-end">
            <div className="md:col-span-3 p-6 md:p-10">
              <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug mb-4">
                Ваши контакты остаются только у нас: передавать их третьим лицам
                не в наших интересах.
              </h3>
              <p className="text-base text-slate-500 leading-relaxed mb-6">
                Контактная информация пациентов используется только для связи по вашему
                обращению и организации лечения в нашей клинике.
              </p>
              <div className="border-t border-slate-200 pt-4">
                <p className="font-semibold text-base">Мошир Амир Резаевич</p>
                <p className="text-sm text-slate-500 leading-snug mt-1">
                  Врач&#8209;имплантолог, челюстно&#8209;лицевой хирург
                  <br />
                  Кандидат медицинских наук — опыт работы 28 лет
                </p>
              </div>
            </div>

            <div className="md:col-span-2 bg-gradient-to-b from-brand-50 to-brand-100 flex justify-center">
              <img
                src={asset("/images/doctor.png")}
                alt="Мошир Амир Резаевич — врач-имплантолог"
                loading="lazy"
                className="h-[260px] md:h-[340px] w-auto object-contain object-bottom"
              />
            </div>
          </div>
        </div>

        {/* Меры защиты */}
        <h3 className="font-heading text-xl md:text-2xl font-bold mb-5">
          Что мы делаем для защиты ваших данных
        </h3>

        <div data-testid="fraud-warning-measures" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8 md:mb-10">
          {MEASURES.map(function (item) {
            return (
              <div key={item.num} className="rounded-2xl bg-white text-slate-800 p-5 md:p-6 h-full">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand-50 text-brand-700 font-bold text-sm mb-4">
                  {item.num}
                </span>
                <p className="font-semibold text-base mb-2">{item.title}</p>
                <p className="text-sm text-slate-500 leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>

        {/* Итог */}
        <div className="rounded-2xl bg-white/15 border border-white/20 p-5 md:p-6 flex flex-col md:flex-row md:items-center justify-between gap-5">
          <p className="text-sm md:text-base text-white/90 leading-relaxed max-w-3xl">
            <ShieldCheck className="w-5 h-5 inline-block mr-2 -mt-1" />
            Для нас доверие пациента — не формальность.{" "}
            <span className="font-semibold text-white">
              Передача контактов третьим лицам противоречит интересам клиники:
            </span>{" "}
            это риск для пациентов, репутации и качества сервиса.
          </p>

          <a
            href={PHONE_HREF}
            data-testid="fraud-warning-phone"
            className="flex-shrink-0 inline-flex items-center justify-center gap-2 h-14 px-6 rounded-full bg-white text-brand-700 hover:bg-brand-50 text-base font-semibold transition-colors"
          >
            <Phone className="w-5 h-5" />
            {PHONE_NUMBER}
          </a>
        </div>
      </div>
    </section>
  );
}
